// extracted by mini-css-extract-plugin
export default {"metaInfo":"StyleAssetThumb_metaInfo__xZ8qd","open":"StyleAssetThumb_open__LNage"};